import React from "react";
import { css, cx } from "emotion";
import { footerStyle } from "./style";

const PanelFooter = ({ className, children }) => {
	return (
		<div
			className={cx(
				css`
					${footerStyle}
				`,
				className
			)}
		>
			{children}
		</div>
	);
};

export default PanelFooter;
